import { SectionPage } from "./SectionPage";

const Section = () => {
	return <SectionPage />;
};
export default Section;
